<template>
  <PagedGenericForm
      v-bind="$props"
      v-on="$listeners"
      :pages-name="pagesComputed"
  >
    <template v-slot:form="props">
     <FacturasStep
          v-if="props.pageIdx === 2"
          v-model="facturas"
          :error-messages="errorMessages"
          @input="emitValue()"
          :readonly="readonly"
          :formValue="props.value"
      >
      </FacturasStep>
      <MercaderiasStep
          v-if="props.pageIdx === 3"
          v-model="mercaderias"
          :error-messages="errorMessages"
          @input="emitValue()"
          :readonly="readonly"
          :formValue="props.value"
      >
      </MercaderiasStep>
      <GenericForm :fields="props.page"
                   v-if="props.page"
                   :value="props.value"
                   :error-messages="props.errorMessages"
                   :disabled="props.disabled"
                   :no-gutters="props.noGutters"
                   :clearable="props.clearable"
                   :headers="props.headers"
                   :readonly="props.readonly"
                   @input="emitValue()" />
      <HistoricoEstados
          v-if="id && props.pageIdx === 5"
          :id-formulario="id"
      />
    </template>
  </PagedGenericForm>
</template>

<script>
import PagedGenericForm from '@/components/generic-fields/PagedGenericForm';
import MercaderiasStep from '@/views/formularios/MercaderiasStep';
import { mapState } from 'vuex';
import HistoricoEstados from '@/views/formularios/HistoricoEstados';
import FacturasStep from '@/views/formularios/FacturasStep';
export default {
name: "FormularioWizard",
  components: { HistoricoEstados, MercaderiasStep, PagedGenericForm, FacturasStep },
  extends: PagedGenericForm,
  props: {
    id: {
      type: String|Number,
    },
  },
  data: () => ({
    mercaderias: [],
    facturas: [],
  }),
  watch: {
    "value.mercaderias": {
      handler(val) {
        this.mercaderias = val || [];
      },
      immediate: true,
    },
    "value.facturas": {
      handler(val) {
        this.facturas = val || [];
      },
      immediate: true,
    },
    mercaderias: {
      handler() {
        this.emitValue();
      },
      deep: true,
    },
    facturas: {
      handler() {
        this.emitValue();
      },
      deep: true,
    },
  },
  methods: {
    emitValue() {
      const value = Object.assign({}, this.value);
      value.mercaderias = this.mercaderias;
      value.facturas = this.facturas;
      this.$emit('input', value);
    },
  },
  computed: {
    esUsuarioSistema() {
      return !!this.usuario.usuario;
    },
    pagesComputed() {
      return this.id ? this.pagesName : this.pagesName.filter((v, i) => i < 5);
    },
    ...mapState('auth', ['usuario']),
  },
}
</script>

<style scoped>

</style>
